import { Iterable, ObjUtils } from "./ObjUtils";
import { List } from "./List";

export class KeyValuePair<K, V> {
	constructor(
		public Key: K,
		public Value: V) {

	}
}

export class Dictionary<K, V> implements Iterable<KeyValuePair<K,V>>{
	// Table is a sparse array do not use length or for-in
	private _table: Array<KeyValuePair<K, V>>;
	private _count: number;

	constructor(other?: Iterable<KeyValuePair<K, V>>) {
		this._table = new Array<KeyValuePair<K, V>>();
		this._count = 0;
		if (other)
			other.ForEach((pair) => {
				this.Add(pair.Key, pair.Value);
			});
	}

	public get Count(): number {
		return this._count;
	}

	public First(): KeyValuePair<K, V> {
		var result: KeyValuePair<K, V> = null;

		this.Some((pair) => {
			result = pair;
			return true;
		});

		return result;
	}

	public Add(k: K, v: V): boolean {
		//if (!k)
		//	return false;

		var index = this.GetHashCode(k);

		while (this._table[index]) {
			if (ObjUtils.Equals(k, this._table[index].Key)) {
				this._table[index].Value = v;
				return false;
			}
			index++;
		}

		this._table[index] = new KeyValuePair<K, V>(k, v);
		this._count++;
		return true;
	}

	private GetHashCode(k: K): number {
		// It is important to keep the hash code non-negative, because negative array indexes
		// in Javascript have strange behavior.  Specifically, negative array indexes are treated
		// as regular object properties, and do not count in the length of the array.  Nor does
		// setting an array's length to zero remove them.

		return Math.abs(ObjUtils.GetHashCode(k));
	}

	public Remove(k: K): boolean {
		//if (k) {
			var index = this.GetHashCode(k);

			while (this._table[index]) {
				if (ObjUtils.Equals(k, this._table[index].Key)) {
					delete this._table[index];
					this._count--;
					return true;
				}
				index++;
			}
		//}
		//return false;
	}

	public Item(k: K): V {
		//if (k) {
			var index = this.GetHashCode(k);

			while (this._table[index]) {
				if (ObjUtils.Equals(k, this._table[index].Key)) {
					return this._table[index].Value;
				}
				index++;
			}
		//}
		//return null;
	}

	public Keys(): List<K> {
		var result = new List<K>();

		this.ForEach((pair: KeyValuePair<K, V>) => {
			result.Add(pair.Key);
		});

		return result;
	}

	public Values(): List<V> {
		var result = new List<V>();

		this.ForEach((pair: KeyValuePair<K, V>) => {
			result.Add(pair.Value);
		});

		return result;
	}

	public Clear(): void {
		this._table.length = 0;
		this._count = 0;
	}

	public ContainsKey(key: K): boolean {
		return this.Item(key) != null;
	}

	public ContainsValue(val: V): boolean {
		return this.Some((pair) => {
			if (ObjUtils.Equals(val, pair.Value)) {
				return true;
			}
		});
	}

	public UnionWith(other: Iterable<KeyValuePair<K, V>>) {
		other.ForEach((pair) => {
			this.Add(pair.Key, pair.Value);
		});
	}

	public ForEach(callbackfn: (value: KeyValuePair<K, V>, index: number, array: KeyValuePair<K, V>[]) => void, thisArg?: any): void {
		for (var key in this._table) {
			if (this._table.hasOwnProperty(key))
				callbackfn(this._table[key], parseInt(key), this._table);
		}
		// FOREACH didn't work with the sparse array
		//this._table.forEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: KeyValuePair<K, V>, index: number, array: KeyValuePair<K, V>[]) => boolean, thisArg?: any): boolean {
		for (var key in this._table) {
			if (this._table.hasOwnProperty(key)) {
				if (callbackfn(this._table[key], parseInt(key), this._table))
					return true;
			}
		}
		return false;
		//return this._table.some(callbackfn, thisArg);
	}

	public Every(callbackfn: (value: KeyValuePair<K, V>, index: number, array: KeyValuePair<K, V>[]) => boolean, thisArg?: any): boolean {
		for (var key in this._table) {
			if (this._table.hasOwnProperty(key)) {
				if (!callbackfn(this._table[key], parseInt(key), this._table))
					return false;
			}
		}
		return true;
		//return this._table.every(callbackfn, thisArg);
	}

}
